export const RewardModelingIcon: React.FC<React.SVGProps<SVGSVGElement>> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.25 2.75C11.25 2.33579 11.5858 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 10.4524 2.35206 8.985 2.98116 7.67527C3.1605 7.3019 3.60857 7.1446 3.98194 7.32394C4.35532 7.50329 4.51261 7.95135 4.33327 8.32473C3.79943 9.43614 3.5 10.682 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.55831 17.0931 3.91233 12.75 3.53263V5.25C12.75 5.66421 12.4142 6 12 6C11.5858 6 11.25 5.66421 11.25 5.25V2.75ZM4.96967 4.96967C5.26256 4.67678 5.73744 4.67678 6.03033 4.96967L10.1126 9.05197C10.6572 8.7026 11.3049 8.5 12 8.5C13.933 8.5 15.5 10.067 15.5 12C15.5 13.933 13.933 15.5 12 15.5C10.067 15.5 8.5 13.933 8.5 12C8.5 11.3049 8.7026 10.6572 9.05197 10.1126L4.96967 6.03033C4.67678 5.73744 4.67678 5.26256 4.96967 4.96967ZM12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z"
        fill="#737373"
      />
    </svg>
  );
};
